import {Spreadsheet} from '../models/spreadsheet';
import numeral from "numeral";


export type sourceDataCustomerSpreadsheet = customerSpreadsheet[];

interface customerSpreadsheet {
    nameStore: string;
    qtySales: number;
}

export class CustomerSpreadsheet extends Spreadsheet {
    name: string = `clientes`;

    mount(dataSource: sourceDataCustomerSpreadsheet) {
        const totalSales = dataSource.reduce((a, b) => a + b.qtySales, 0);
        const getPercentage = (obj: customerSpreadsheet): string =>
            numeral(obj.qtySales / totalSales).format('0.00%');

        const maxLengthNameStore = Math.max.apply(null, dataSource.map(z => z.nameStore.length));
        const sizeNameStore = 50 + (maxLengthNameStore * 8);

        this.workbookOptions = {
            sheets: [{
                name: 'Clientes',
                rows: [
                    {
                        cells: ['Nome Loja', 'Total', 'Percentage']
                            .map((value, index) => ({
                                index, value, background: '#666', textAlign: 'center', color: 'white', bold: true,
                            }))
                    },
                    ...dataSource.map((obj, lineIndex) => ({
                        cells: [o => o.nameStore, o => o.qtySales, getPercentage]
                            .map((callbackValue, index) => {
                                const isOdd = lineIndex % 2 === 0;
                                const isFirstColumn = index === 0;

                                return {
                                    index,
                                    value: callbackValue(obj),
                                    background: isOdd ? '#ddd' : '#fafafa',
                                    textAlign: isFirstColumn ? 'left' : 'center',
                                    bold: isFirstColumn,
                                    color: 'black'
                                };
                            })
                    }))
                ],
                columns: [
                    {width: sizeNameStore},
                    {width: 85},
                    {width: 110}
                ]
            }]
        };

        return this;
    }
}



// WEBPACK FOOTER //
// ./src/spreadsheets/customer-spreadsheet.js